<template>
  <div>
    <div class="top_bg">
      <img src="@/assets/images/product_bg.jpg" alt="">
    </div>
    <div class="defult_title">
        <h1>{{language === 'E' ? 'INDUSTRY NEWS' : '行业新闻'}}</h1>
        <p>{{language === 'E' ? '行业新闻' : 'INDUSTRY NEWS'}}</p>
      </div>
    <div class="defult_width industry-news-list">
      <el-row class="news-box">
        <ul>
          <li v-for="(item, key) in newsList" :key="key" v-show="(currentPage - 1) * 10 <= key && key < currentPage * 10">
            <router-link :to="`newsDetail/${item.id}`" v-if="key < currentPage * 10">
              <div class="time">
                <p>
                  {{ item.time.month }}
                </p>
                <span>
                  {{ item.time.year }}
                </span>
              </div>
              <div class="list">
                  <h5>
                  {{ item.name }}
                  </h5>
                  <p>
                    {{ (item.detail).substring(0, 90) + '...' }}
                  </p>
              </div>
            </router-link>
          </li>
        </ul>
      </el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentChange"
        :current-page="currentPage"
        :hide-on-single-page="true"
        :total="newsList.length">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import news from '@/datas/news'
import Enews from '@/EnglishData/news'
export default {
  name: 'ProductCenter',
  data () {
    const language = localStorage.getItem('language')
    let languageNews = null
    if (language && language === 'E') {
      languageNews = Enews
    } else {
      languageNews = news
    }
    const { newsList } = languageNews
    return {
      newsList, // 新闻列表
      language,
      currentPage: 1 // 当前页数
    }
  },
  created () {
  },
  methods: {
    currentChange (page) {
      this.currentPage = page
    }
  }
}
</script>
<style lang="less" scoped>
.industry-news-list {
  padding: 20px 0 50px;
  .news-box {
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 45%;
        a {
          display: block;
          padding: 20px 0;
          border-bottom: 1px solid #e5e5e5;
          overflow: hidden;
          .time {
            text-align: left;
            width: 18%;
            float: left;
            p {
              font-size: 30px;
              color: #4a4a4a;
            }
            span {
              color: #767676;

            }
          }
          .list {
            width: 82%;
            float: right;
            text-align: left;
            h5 {
              font-size: 18px;
              color: #4a4a4a;
              line-height: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
            }
            p {
              line-height: 24px;
              min-height: 80px;
              color: #767676;
            }
          }
        }
      }
    }

  }

}
</style>



// WEBPACK FOOTER //
// src/view/news/IndustryNews.vue